import { html } from 'lit';
import componentStyles from './spacing-container.css.lit.ts';
import QueryComponent from '../../base/query-component/QueryComponent.js';

export default class SpacingContainer extends QueryComponent {
  static styles = [super.styles, componentStyles];

  static get properties() {
    return {
      text: { type: String },
    };
  }

  render() {
    return html`<slot></slot>`;
  }
}

customElements.define('hf-spacing-container', SpacingContainer);
